const payoutTypes = ['CASH_SALES', 'EXTERNAL_PAYMENT', 'DELIVEROO', 'OTHER_DELIVERY_SERVICES'];

export default payoutTypes;
